import { Component, OnInit, OnDestroy } from '@angular/core';

// import { REPORTS } from '../models/reports';
import { PagerService } from '../../../services/pager.service';
import { GlobalService } from '../../../services/global.service';
import { SnackBarService } from '../../../shared/snackbar/snackbar.service';
import { LoadingService } from '../../../shared/loading/loading.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { BasicQuestionComponent } from '../../../shared/modal/basic-question/basic-question.component';

import Utils from '../../../shared/utility';

@Component({
  selector: 'app-nw-internal-users',
  templateUrl: './internal-users.component.html',
  styleUrls: ['./internal-users.component.css']
})
export class InternalUserNWComponent implements OnInit, OnDestroy {
  private reports: any[];
  private error:string;

  private allItems: any[];
  private filteredReports: any[];
  pager: any = {};
  pagedItems: any[];
  logoImage = "https://web234.hvsfinancial.com/portal-shared/OrgLogos/239/239_1525814246.282_logo.jpg";
  //localStorage.getItem('logoPhotoPath') !== 'null' ? "https://web234.hvsfinancial.com/portal-shared/" + localStorage.getItem('logoPhotoPath') : 'https://web234.hvsfinancial.com/portal/assets/images/temp/logo.png';
  isLoading: boolean = true;
  token;
  accessToDelete = Number(localStorage.getItem('roleId')) == 1 || (Number(localStorage.getItem('parentID')) == 0 && (Number(localStorage.getItem('roleId')) == 2));

  constructor(private pagerService: PagerService, public dialog: MatDialog, private globalService: GlobalService, 
    private snackBarService: SnackBarService, private loadingService: LoadingService, public router: Router) { 
      //find variabled being passed to the UI
      
  }

  ngOnInit() {
    //make call to the API
    var query = this.router.url;
    //var query2 = query.split('/clientReports/');
    var query2 = query.split('/');
    //console.log('url', query2);
    //if returned true, display reports for the client selected
    if(query2.length > 0){
      
      this.token = query2[3];
      this.getReports(query2[2]);

    } else {
      //display message? reroute to login?
      window.open(window.location.origin + "/#/login", "_SELF");
      //this.router.navigate(['/login']);
    }
  }

  ngOnDestroy() {
    //localStorage.setItem("internalClientReportID", ""); //empty storage
    console.log('left page')
  }

  login(){
    window.open(window.location.origin + "/#/login", "_SELF");
  }

  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }

    // get pager object from service
    this.pager = this.pagerService.getPager(this.filteredReports.length, page);

    // get current page of items
    this.pagedItems = this.filteredReports.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  assignCopy(){
    this.filteredReports = Object.assign([], this.allItems);
  }
  
  filterItem(value){

    this.filteredReports = Object.assign([], this.allItems).filter(
      report => {
        return (report.c.FirstName + " " + report.c.LastName + " " + report.c.spouseName).toLowerCase().includes(value.toLowerCase()) || (report.o.Name).toLowerCase().includes(value.toLowerCase()) || (report.a.FirstName + " " + report.a.LastName).toLowerCase().includes(value.toLowerCase())
      }
    );
    
    if (!this.filteredReports.length) {
      this.pagedItems = [];
    } else {
      this.setPage(1);
    }
  }

  getReports(clientID) {
    //TODO: needs to be configured to just return selected client info/reports
    this.loadingService.isLoading(true);
    this.globalService.getClientReportsDataSSO(clientID)
        .subscribe(
            reports => { 
              console.log('returned', reports);
              var allReports = [];

              for (var type in reports) {
                reports[type].forEach((report) => {
                   
                  if (report.ss) {
                    
                    report.c.annualIncome = "120,000";
                    report.c.irr = 100;
                    report.c.spouseName = report.ss.MaritalState == 'Married' ? report.ss.FrmName1 : '';
                  } else if (report.mmt) {
                    
                    report.c.annualIncome = "120,000";
                    report.c.irr = 100;
                    report.c.spouseName = report.mmt.IncludePartner == 'True' ? report.mmt.FrmName1 : '';
                  } else if (report.hc) {
                    
                    report.c.annualIncome = "120,000";
                    report.c.irr = 100;
                    report.c.spouseName = report.hc.FrmIncome.toLowerCase().includes('mfj') ? report.hc.FrmName1.includes('undefined') ? report.hc.FrmName1.replace('undefined', '') : report.hc.FrmName1 : '';
                  } else if (report.ltc) {
                    
                    report.c.annualIncome = "120,000";
                    report.c.irr = 100;
                    report.c.spouseName = report.ltc.IncludePartner == 'True' ? report.ltc.FrmName1 : '';
                  }

                  allReports.push(report);
                });
              }        

              this.reports = allReports;
              
              this.allItems = this.reports;
              console.log('report', this.allItems);

              this.filteredReports = this.reports.sort(function(a, b) {
                return parseInt(b.r.ID) - parseInt(a.r.ID);
              });
              
              this.setPage(1);
              this.loadingService.isLoading(false);
              this.isLoading = false;
            },
            error => {
              this.error = <any>error
              this.loadingService.isLoading(false);
              //console.log('errored');
              window.open(window.location.origin + "/#/login", "_SELF");
            });
  }

  downloadReport(e, report) {
    // console.log(report);
    this.loadingService.isLoading(true);

    var reportID = report.r.ReportID;
    var advisorID = report.r.AdvisorID;
    var clientID = report.r.ClientID;
    var orgID = report.r.CompanyCode;
    var reportTypeID = report.r.ReportTypeID;

    // console.log(report);

    var ReportFields = { reportID, advisorID, clientID, orgID, reportTypeID, token: this.token };
    this.snackBarService.add(`Downloading your ${Utils.formatReportTypeID(reportTypeID)} report`, 0);
    
    this.globalService.generateReport(ReportFields, report.c, report.r)
      .subscribe(
      resp => {
        // console.log('downloading report');
        this.loadingService.isLoading(false);
      },
      error => {
        this.error = <any>error;
        this.loadingService.isLoading(false);
      });
  }

  deleteReport(e, report){
    //display popup asking if they are sure they want to delete
    const dialogRef = this.dialog.open(BasicQuestionComponent, {     
      data: { title: 'Notification!',
      btnNoTitle: 'Cancel',
      btnYesTitle: 'Delete',
      question: "Are you sure you want to delete this report?" }
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log('result', result);  
      if(result){
        //display snackbar - no loading needed
        this.snackBarService.add(`Report has been permanently deleted.`, 0);

        //remove row from current list by index/ID - no need to rerun GetReports
        this.filteredReports = this.filteredReports.filter((obj) => obj.r.ReportID !== report.r.ReportID);
        this.setPage(1);

        //make call to API service to remove from DB
        var ReportID = report.r.ReportID;
        var AdvisorID = report.r.AdvisorID;
        var ClientID = report.r.ClientID;
        var CompanyCode = report.r.CompanyCode;
        var ReportTypeID = report.r.ReportTypeID;

        var ReportFields = { ReportID, AdvisorID, ClientID, CompanyCode, ReportTypeID };
        this.globalService.deleteReport(ReportFields).subscribe(
        resp => {
          //async call - dont care on the return, we filter out the items from current list on-the-fly
        },
        error => {
          this.error = <any>error;
        });
      }
    });
  }

  formatDate(date) {
    date = new Date(date);
    return date > 1/1/1900 ? (date.getMonth() + 1) + '/' + date.getDate() + '/' +  date.getFullYear() : '--';
  }

  formatReportTypeID(ReportTypeID: number) {
    return Utils.formatReportTypeID(ReportTypeID);
  }
 
}
